import * as React from 'react';
import { useRef, useEffect } from 'react';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import { isH5HandleClient } from 'eco-design-micro/utils-base/isH5Handle';

const CoverSectionEU: React.FC = () => {
    const { t } = useLang('CoverSectionEU2');
    const sectionRef = useRef<HTMLDivElement>(null);
    const darkLayerRef = useRef<HTMLDivElement>(null);
    const isMobile = isH5HandleClient(); //是否是移动端
    useEffect(() => {
        if (typeof window === 'undefined') return;
        const el = sectionRef.current;
        if (!el) return;

        const scene = AniContainer.create({
            triggerElement: el,
            triggerHook: 1,
            offset: window.innerHeight * (isMobile ? 0.65 : 0.5),
            duration: window.innerHeight * 0.7,
            onProcess: (progress: number) => {
                if (!darkLayerRef.current) return;
                const p = Math.max(0, Math.min(progress, 1));
                // solid core expands to 80%, soft feather edge extends 30% beyond
                const solidR = p * 80;
                const fadeR = solidR + 30;
                const mask = `radial-gradient(circle at 50% 50%, black ${solidR}%, transparent ${fadeR}%)`;
                darkLayerRef.current.style.maskImage = mask;
                darkLayerRef.current.style.webkitMaskImage = mask;
            },
        });

        return () => scene.destroy?.();
    }, []);

    const content = (
        <>
            <div className="label">{t('label')}</div>
            <div className="title-wrap">
                <div className="title">{t('title')}</div>
            </div>
            <div className="desc">{t('desc')}</div>
        </>
    );

    return (
        <div
            ref={sectionRef}
            className={`page-CoverSectionEU2 range2 ${styles.CoverSectionEU} GtmModuleData-section`}
            data-section-id="d3c-CoverSectionEU2"
        >
            <div className="text-container">
                <div className="layer-base">{content}</div>
                <div ref={darkLayerRef} className="layer-dark" aria-hidden="true">
                    {content}
                </div>
            </div>
        </div>
    );
};

export default CoverSectionEU;
